
import { mapGetters } from 'vuex'
export default {
  props: {
    diagram: { type: Object },
    showLabel: { type: Boolean, default: true }
  },
  data () {
    return {
      pending: false
    }
  },
  computed: {
    ...mapGetters('favourites', ['isFavourite']),
    isFavouriteDiagram () {
      return this.isFavourite(this.diagram.id)
    }
  },
  methods: {
    async onFavouriteClick () {
      this.pending = true
      if (this.isFavouriteDiagram) {
        await this.$store.dispatch(
          'favourites/removeFavourite',
          {
            diagram: this.diagram,
            $backend: this.$backend,
            $gtag: this.$gtag,
            $matomo: this.$matomo
          })
      } else {
        await this.$store.dispatch(
          'favourites/addFavourite',
          {
            diagram: this.diagram,
            $backend: this.$backend,
            $gtag: this.$gtag,
            $matomo: this.$matomo
          })
      }
      this.pending = false
    }
  }
}
